<button *ngIf="form && checkPermissions('add_subject_to_practice_create')" matTooltip="addSubject" type="button" [disabled]="disabledButton()"
    class="my-bounce btn closeRequestButton mx-2 clsButtonDefault marginBottom10" (click)="openModal()">
    {{ 'LABEL.addSubjectToPractice' | translate }}
</button>
<br>
<app-data-table [sortActive]="sortActive" [data]="subjectRelatedToPractices || []" [displayedColumns]="displayedColumns" [columns]="columns"
[actions]="actions" [hasPagination]="false" [hasHeader]="true">
</app-data-table>